import { lazy } from "react"

/**
 * Wrapper around React.lazy that retries once on chunk load failure,
 * then forces a page reload if the retry also fails.
 * Handles stale deploys where old chunk URLs 404.
 */
export function lazyRetry(
	load: () => Promise<{ default: React.ComponentType }>,
): React.LazyExoticComponent<React.ComponentType> {
	return lazy(
		() =>
			load().catch(() => {
				// First attempt failed — retry once
				return load().catch(() => {
					// Both attempts failed — stale deploy, try reloading the page
					const last = Number(sessionStorage.getItem("chunk_reload") || 0)
					if (Date.now() - last > 10_000) {
						sessionStorage.setItem("chunk_reload", String(Date.now()))
						window.location.reload()
						// Never-resolving promise prevents error flash during reload
						return new Promise<never>(() => {})
					}
					// Debounce blocked reload — let ErrorBoundary show a reload button
					throw new Error("Failed to load page. Please reload.")
				})
			}) as Promise<{ default: React.ComponentType }>,
	)
}
